import React from 'react';
import { IField } from '../../../../../shared/interfaces';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import { RootState } from '../../../../../store';
import { connect, ConnectedProps } from 'react-redux';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';


const mapState = (state: RootState) => ({
})
const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface FormUserPrintAndSendProps {
    loading?: boolean
    extraCssClass?: string
    userPrintAndSend: IField[]
    onInputChangedHandler: (newField: IField) => void
}

type Props = FormUserPrintAndSendProps & PropsFromRedux

const FormUserPrintAndSendProps: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;
   
    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <DynamicForm
                fields={props.userPrintAndSend}
                onInputChangedHandler={(newField) => { props.onInputChangedHandler(newField) }}
            />

        </React.Fragment>
    );
}

export default connector(FormUserPrintAndSendProps);